import React from 'react';
import Button from '@material-ui/core/Button';
import { Card } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import Item from './item';

export default class Add extends React.Component {

  constructor() {
    super();
    this.state = {
      items: [],
      selectedItems: [],
      customerTypes: [],
      load: false,
      message: 'Loading',
      items1: [],
    }
  }

  componentDidMount() {
    this.getCustomerTypes();
  }

  getCustomerTypes() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Executive!!!',
      menucontrol: false
    });
    let data1 = {};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'menucontrol/getcustomertypes.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          context.setState({
            customerTypes: data
          }, () => {
            context.addItem();
          });
        } catch (e) {
          context.setState({
            load: false,
          });
        }

      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!')
      }
    });
  }

  addItem = () => {
    let items = this.state.items;
    let id = items.length;
    items.push({id: id});
    this.setState({
      items
    });
  }

  updateItem = (id, type, value) => {
    let items = this.state.items;
    for (var i = 0; i < items.length; i++) {
      if (type == 'menu') {
        if (items[i].id == id) {
          items[i][type] = value;
        }
      }
      if (type == 'type') {
        if (items[i].id == id) {
          items[i][type] = value;
        }
      }
      if (type == 'executive') {
        if (items[i].id == id) {
          items[i][type] = value;
        }
      }
    }
    this.setState({
      items: items
    });
    this.props.updatedata(items, type);
  }

  removeItem = (id) => () => {
    let items = [];
    this.state.items.map((x) => {
      if (x.id != id) {
        items.push(x);
      }
    });
    this.setState({ items });
  }

  render() {
    let { executives, id } = this.props;
    let selectedItem = '';
    this.state.items.map((x) => {
      if (x.menu) {
        selectedItem = x.menu;
      }
    });

    let selectedType = '';
    this.state.items.map((x) => {
      if (x.type) {
        selectedType = x.type;
      }
    });


    let items = this.state.items.map((x) => {
      return (
        <Item id={x.id} updateItem={this.updateItem}
          selectedItem={selectedItem}
          selectedType={selectedType}
          remove={this.removeItem}
          customerTypes={this.state.customerTypes}
          executives={this.props.executives} data={x}/>
      );
    });
    const { load, message } = this.state;
    return (
      <div style={{padding: '2%'}}>
        <Loading load={load} message={message} />
        <Card fluid style={{padding: '2%'}}>
        {items}
        <Button variant="contained"
            onClick={this.addItem}
            color="primary" fullWidth>
            Add New
        </Button>
        </Card>
      </div>
    );
  }

}
